/* global axios */
import ApiClient from './ApiClient';

class DashboardHomeAPI extends ApiClient {
  constructor() {
    super('dashboard', { accountScoped: true });
  }

  getHomeStats() {
    return axios.get(`${this.baseUrl()}/dashboard/home_stats`);
  }
}

export default new DashboardHomeAPI();
